import React, { useState, useEffect, useCallback } from 'react';
import { onCapabilityError, CapabilityErrorCode } from '../lib/capabilityError';
import TrialExpiredModal from './TrialExpiredModal';
import { toast } from 'sonner';

/**
 * Provider that listens for capability errors and shows appropriate modals/toasts
 */
const CapabilityErrorProvider = ({ children }) => {
  const [showTrialModal, setShowTrialModal] = useState(false);

  const handleCapabilityError = useCallback((error) => {
    switch (error.code) {
      case CapabilityErrorCode.TRIAL_EXPIRED:
        setShowTrialModal(true);
        break;
      
      case CapabilityErrorCode.ACCOUNT_BLOCKED:
        toast.error(error.message || 'Cuenta bloqueada. Contacta con soporte.');
        break;
      
      case CapabilityErrorCode.PERMISSION_DENIED:
      case CapabilityErrorCode.ROLE_DENIED:
        toast.error(error.message || 'No tienes permisos para realizar esta acción.');
        break;
      
      default:
        toast.error(error.message || 'Acción no permitida.');
    }
  }, []);

  useEffect(() => {
    const unsubscribe = onCapabilityError(handleCapabilityError);
    return unsubscribe;
  }, [handleCapabilityError]);

  return (
    <>
      {children}
      <TrialExpiredModal 
        isOpen={showTrialModal} 
        onClose={() => setShowTrialModal(false)} 
      />
    </>
  );
};

export default CapabilityErrorProvider;
